import React from "react";
import styled from "styled-components";

const AspectRatioContainer = styled.div`
  position: relative;

  &:before {
    display: block;
    content: "";
    width: 100%;
    padding-top: ${(props) => props.padding}%;
  }

  & > .content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

// Takes in the image, children and padding
// Image can be null if you want to set it a hardcoded padding value
// Used for displaying images quicker and preventing unnecessary layout paints and jumps
export const AspectRatioImageContainer = ({
  children,
  image,
  bgColor,
  padding,
}) => {
  if (image === null) {
    return (
      <AspectRatioContainer
        padding={padding}
        bgColor={bgColor}
        className="aspect-ratio-container"
      >
        <div className="content">{children}</div>
      </AspectRatioContainer>
    );
  } else {
    const aspectRatioWidth = image.dimensions.width;
    const aspectRatioHeight = image.dimensions.height;
    const aspectRatio = (aspectRatioHeight / aspectRatioWidth) * 100;

    return (
      <AspectRatioContainer
        padding={aspectRatio}
        bgColor={bgColor}
        className="aspect-ratio-container"
      >
        <div className="content">{children}</div>
      </AspectRatioContainer>
    );
  }
};
